module.exports = __webpack_public_path__ + "static/media/StageScreen.02f7947d.png";